import { render, staticRenderFns } from "./CompositionsList.vue?vue&type=template&id=23d19610&scoped=true&lang=pug&"
import script from "./CompositionsList.vue?vue&type=script&lang=js&"
export * from "./CompositionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d19610",
  null
  
)

export default component.exports